module.exports = __webpack_public_path__ + "img/bf78df2.svg";